export type TourHeaderProps = {
  avatar_url?: string | null;
  color?: string | null;
  display_name: string;
  guide_website_url?: string | null;
  i18n_locale?: string | null;
  is_selective?: boolean;
  linkable_header?: boolean;
  logo?: string | null;
  tour?: { i18n_locale?: string | null } | null;
};

export const resolveTourHeaderLocale = (
  props: Pick<TourHeaderProps, 'tour' | 'i18n_locale'>
): string | null | undefined => props.tour?.i18n_locale ?? props.i18n_locale;
